<div
  class="device-container d-flex flex-column justify-content-center"
  tabindex="0"
  *ngIf="perk"
  [class.min-height-145]="count === 2 && !isMobile && !isPartnerLabelActive"
  [class.min-height-165]="count === 2 && isPartnerLabelActive"
  [class.min-height-260]="(count > 2 || isMobile) && !isPartnerLabelActive"
  [class.min-height-285]="count > 2 && isPartnerLabelActive"
  (click)="handlePerkClick()"
  (keypress)="handlePerkKeyDown($event)"
  [gtmClick]="getLabel(perk + '_Heading')"
  [gtmLinkURL]="perkButtonRoute">
  <adp-setting [key]="perk + '_SvgIcon'"></adp-setting>
  <adp-setting [key]="'URL_' + perk"></adp-setting>
  <adp-setting [key]="perk + '_Button_OpenInNewWindow'"></adp-setting>
  <div class="d-flex flex-column">
    <div class="d-flex justify-content-end" *ngIf="partnerLabel">
      <div class="perk-badge">
        <adp-label [labelKey]="perk + '_PartnerLabel'"></adp-label>
      </div>
    </div>

    <div class="d-flex p-2" *ngIf="count === 2 && !isMobile">
      <div class="icon-container" *ngIf="perkSvgIcon">
        <mat-icon class="ml-10" [svgIcon]="perkSvgIcon"></mat-icon>
      </div>
      <div class="d-flex align-items-center mr-3" *ngIf="!perkSvgIcon">
        <div class="device-img">
          <adp-image [imageKey]="'Global_' + perk + '_Image'"></adp-image>
        </div>
      </div>
      <p class="u-heading-5" *ngIf="isMobile">
        <adp-label [labelKey]="perk + '_Heading'"></adp-label>
      </p>
      <div class="d-flex" style="width: 100%">
        <div class="d-flex flex-column padding-10" style="width: 100%">
          <p class="u-heading-5" *ngIf="!isMobile">
            <adp-label [labelKey]="perk + '_Heading'"></adp-label>
          </p>
          <p class="u-body-2">
            <adp-label [labelKey]="perk"></adp-label>
          </p>

          <!--<ng-container *ngIf="perkButtonRoute && !isTutorial">
            <a [target]="perkButtonOpenInNewWIndow ? '_blank' : '_self'" class="ctl-margin ml-20"
               href="{{perkButtonRoute}}" [ariaLabel]="perkButtonAria">
              <adp-label [labelKey]="perk + '_Button'"></adp-label>
            </a>
          </ng-container>-->
          <!--<ng-container *ngIf="perkButtonRoute && isTutorial">
            <button style="padding:0px;" class="link ml-20" (click)="openTutorial()" [ariaLabel]="perkButtonAria">
              <adp-label [labelKey]="perk + '_Button'"></adp-label>
            </button>
          </ng-container>-->
        </div>
        <!--<mat-divider [vertical]="true" style="flex-grow:1;"></mat-divider>-->
        <div class="redirect-button" fxLayout="row" fxLayoutAlign="start center">
          <ng-container *ngIf="!isTutorial">
            <a
              [target]="perkButtonOpenInNewWIndow ? '_blank' : '_self'"
              class="ctl-margin"
              href="{{ perkButtonRoute }}"
              [ariaLabel]="perkButtonAria">
              <mat-icon [svgIcon]="'chevron-right-card-gray'"></mat-icon>
            </a>
          </ng-container>
          <ng-container *ngIf="isTutorial">
            <button style="padding: 0px; margin-left: 0px" class="link ml-20" (click)="openTutorial()" [ariaLabel]="perkButtonAria">
              <mat-icon [svgIcon]="'chevron-right-card-gray'"></mat-icon>
            </button>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="d-flex pt-3 pl-3 pb-3 pr-2" *ngIf="count > 2 || isMobile">
      <div class="d-flex" style="width: 100%">
        <div class="d-flex flex-column" style="width: 100%">
          <ng-container *ngIf="!isMobile">
            <div *ngIf="perkSvgIcon">
              <mat-icon class="ml-10" [svgIcon]="perkSvgIcon"></mat-icon>
            </div>
            <div class="d-flex align-items-center" *ngIf="!perkSvgIcon">
              <div class="device-img">
                <adp-image [imageKey]="'Global_' + perk + '_Image'"></adp-image>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isMobile">
            <div class="d-flex">
              <div *ngIf="perkSvgIcon">
                <mat-icon class="ml-10" [svgIcon]="perkSvgIcon"></mat-icon>
              </div>
              <div class="d-flex align-items-center mr-2" *ngIf="!perkSvgIcon">
                <div class="device-img">
                  <adp-image [imageKey]="'Global_' + perk + '_Image'"></adp-image>
                </div>
              </div>
            </div>
            <div class="u-heading-5 mt-4" *ngIf="perkHeading">
              <adp-label [labelKey]="perk + '_Heading'"></adp-label>
            </div>
          </ng-container>
          <p class="u-heading-5 mt-4" *ngIf="perkHeading && !isMobile">
            <adp-label [labelKey]="perk + '_Heading'"></adp-label>
          </p>
          <p class="u-body-2">
            <adp-label [labelKey]="perk"></adp-label>
          </p>
          <!--<ng-container *ngIf="!isTutorial">
            <a [target]="perkButtonOpenInNewWIndow ? '_blank' : '_self'" class="ctl-margin ml-20"
              href="{{perkButtonRoute}}" [ariaLabel]="perkButtonAria">
              <adp-label [labelKey]="perk + '_Button'"></adp-label>
            </a>
          </ng-container>
          <ng-container *ngIf="isTutorial">
            <button style="padding:0px;" class="link ml-20" (click)="openTutorial()" [ariaLabel]="perkButtonAria">
              <adp-label [labelKey]="perk + '_Button'"></adp-label>
            </button>
          </ng-container>-->
        </div>
        <!--<mat-divider [vertical]="true"></mat-divider>-->
        <div class="redirect-button" fxLayout="row" fxLayoutAlign="start center">
          <ng-container *ngIf="!isTutorial">
            <a
              [target]="perkButtonOpenInNewWIndow ? '_blank' : '_self'"
              class="ctl-margin"
              href="{{ perkButtonRoute }}"
              [ariaLabel]="perkButtonAria">
              <mat-icon [svgIcon]="'chevron-right-card-gray'"></mat-icon>
            </a>
          </ng-container>
          <ng-container *ngIf="isTutorial">
            <button style="padding: 0px; margin-left: 0px" class="link ml-20" (click)="openTutorial()" [ariaLabel]="perkButtonAria">
              <mat-icon [svgIcon]="'chevron-right-card-gray'"></mat-icon>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
